export default "__VITE_ASSET__CkmXMSlX__"